<template>
  <div
    class="journey-group-item py-2"
    :data-segment-index="segmentIndex"
    :data-unique-index="journey.uniqueKey"
    v-bind:class="currentSelectedClass"
    :style="styleObject"
  >
    <div class="journey-container">
      <!-- Desktop View -->
      <div class="columns is-mobile is-gapless mb-0 pr-1 is-hidden-touch">
        <!-- AIRLINE LOGO -->
        <div class="column is-narrow has-text-centered wrap">
          <div class="mt-1 airlineLogo">
            <img
              width="20"
              :src="$helpers.airlineLogo(journey.airlineCode, 20, 20)"
              :title="$helpers.airlineName(journey.airlineCode)"
            />
          </div>
        </div>
        <!-- FROM-TO -->
        <div class="column is-narrow" style="width:150px">
          <div class="columns is-mobile is-gapless mb-2">
            <div class="column is-narrow mr-2">
              <div class="has-text-weight-bold" data-test="result-journey-from">
                {{ journey.from }}
              </div>
            </div>
            <div class="column is-narrow mr-2">
              <span class="is-size-7 mt-1 is-block">
                <b-icon
                  icon="arrow-right"
                  size="is-small"
                  class="has-text-grey-light"
                ></b-icon>
              </span>
            </div>
            <div class="column is-narrow mr-4">
              <div class="has-text-weight-bold" data-test="result-journey-to">
                {{ journey.to }}
              </div>
            </div>
            <div
              v-if="roundTripDifferentAirports && journeyIndex == 1"
              class="column is-narrow ml-1"
            >
              <span class="has-text-danger is-size-7">multiple airports</span>
            </div>
          </div>
          <div class="columns mb-1">
            <div
              data-test="result-airline-name"
              class="is-size-7 has-text-grey-light ml-3"
            >
              {{ $helpers.airlineName(journey.airlineCode) }}
            </div>
          </div>
          <div class="columns mb-1">
            <div class="is-size-7 has-text-grey-light ml-3">
              <PreferredVendorTag
                class="mt-3"
                position="is-right"
                v-if="isPreferredVendor"
                type="air"
              ></PreferredVendorTag>
            </div>
          </div>
        </div>
        <!-- DEPARTURE-ARRIVAl -->
        <div class="column is-narrow" style="width:200px">
          <div class="is-inline is-size-7" data-test="result-flight-time">
            {{ journey.legs[0].departingAt.time | formatTime }} -
            {{ journey.legs.slice(-1).pop().arrivingAt.time | formatTime }}
          </div>
          <span class="is-block is-size-7 has-text-grey-light">
            <!-- {{ journey.legs[0].departingAt.date | formatDate}} -->
            <span
              class="is-size-7 has-text-danger"
              v-if="journey.dateDifference > 0"
            >
              +{{ journey.dateDifference }}
              <span v-if="journey.dateDifference == 1">day</span>
              <span v-if="journey.dateDifference > 1">days</span>
            </span>
          </span>
          <!--<span class="is-block is-size-7 ml-2 has-text-danger" v-if="journey.dateDifference > 0">
            <span v-if="journey.dateDifference == 1">arrives next day</span>
            <span v-if="journey.dateDifference > 1">arrives {{ journey.dateDifference }} days layer</span>
          </span>-->
        </div>
        <!-- DURATION & STOPS -->
        <div class="column has-text-left mr-4">
          <span
            data-test="result-total-duration"
            class="has-text-grey-dark is-size-7 mr-2"
            >{{ journey.travelDuration | formatDuration }}</span
          >

          <span
            data-test="result-total-stop"
            class="has-text-grey is-size-7 ml-2"
            >{{ (journey.legs.length - 1) | formatLayovers }}
          </span>

          <span
              v-for="(layover, index) in journey.layovers"
              :key="`layover-${index}`"
              class="is-size-7 has-text-grey"
            >

              <span class="mx-1 has-text-grey-light">
                &bull;
              </span>

              <span class="has-text-weight-bold mr-1">
                {{ layover.airport }}
              </span>
            
              
              <span v-bind:class="getLayoverClass(layover.durationInMinutes)">
                {{ layover.durationInMinutes | formatDuration }}
              </span>

            </span>

        </div>
        <!-- UNUSED TICKET -->
        <div class="column has-text-centered is-narrow" style="width:40px;">
          <div
            class="is-inline-block"
            v-if="unusedTickets.includes(journey.airlineCode)"
          >
            <b-icon icon="currency-usd" size="is-small" type="is-info"></b-icon>
          </div>
        </div>

        <!-- PRICE RANGE -->
        <div class="column is-narrow has-text-right mr-4" style="width:120px">
          <span class="has-text-grey-dark is-size-7 has-text-weight-bold">
            <span data-test="result-price-range-display">{{
              priceRangeDisplay
            }}</span>
          </span>
        </div>
        <!-- FARE RULES (One-Way Only) -->
        <div class="column is-narrow" v-if="isOneWay" style="width:40px;">
          <div class="is-flex">
            <div
              class="is-inline-block mr-2 is-clickable"
              @click="fareRulesModal(journey)"
            >
              <b-icon
                icon="alpha-f-circle"
                size="is-default"
                class="has-text-grey-lighter"
              >
              </b-icon>
            </div>
          </div>
        </div>

       <div class="column is-narrow mr-2">
        <div class="columns is-mobile mb-0">
        <!-- FLIGHT INFO -->
        <div class="column is-narrow" style="width: 100px;">
          <div class="is-flex">
            <div
              class="is-inline-block mr-2 is-clickable"
              data-test="result-view-details"
              @click="toggleDetails"
            >
              <!--              <b-icon-->
              <!--                  icon="information"-->
              <!--                  size="is-default"-->
              <!--                  class="has-text-grey-lighter"-->
              <!--              />-->
              <b-button type="is-outlined" size="is-small"
                >View Details</b-button
              >
            </div>
          </div>
        </div>

        <!--  SEAT MAP -->
        <!--        <div class="column is-narrow mr-1" v-if="isOneWay">-->
        <!--          <div class="is-flex">-->
        <!--            <div class="is-inline-block is-clickable" @click="goToSeatMaps()">-->
        <!--              <b-button type="is-outlined" size="is-small">-->
        <!--                <span class="">Seat Maps</span>-->
        <!--              </b-button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- SELECT/DESELECT BUTTONS -->
        <div class="column is-narrow mr-2" style="width: 70px;">
          <div class="is-flex">
            <div v-if="!isOneWay">
              <div
                class="is-inline-block is-clickable"
                data-test="result-button-select"
                @click="selectOption(journey)"
                v-if="!isSelected"
                style="width: 70px;"
              >
                <b-button type="is-outlined" size="is-small">Select</b-button>
              </div>
              <div
                class="is-inline-block is-clickable"
                data-test="result-button-unselect"
                @click="unselectOption(journey)"
                v-if="isSelected"
                style="width: 70px;"
              >
                <b-button active type="is-outlined" size="is-small"
                  >Unselect</b-button
                >
              </div>
            </div>
            <div v-if="isOneWay">
              <div
                class="is-inline-block is-clickable"
                @click="checkSubmission(findOneWayItem(journey))"
                data-test="result-button-book"
                style="width: 70px;"
              >
                <b-button type="is-primary" size="is-small">Book</b-button>
              </div>
            </div>
          </div>
        </div>
        </div>
            <b-tag v-if="upsellsCount > 0 " class="is-small">
              {{ fareDescription }}
            </b-tag> 

            <NDCTag v-if="ndcFare"
            class="mt-1"
            position="is-left"
          ></NDCTag>
 
        </div>
      </div>
      <!-- end of .columns -->
      <!-- end of Desktop View -->

      <!-- Mobile View  -->
      <div class="is-hidden-desktop">
        <div class="is-flex is-justify-content-space-between">
          <div>
            <NDCTag v-if="ndcFare"
            position="is-top"
          ></NDCTag>
            <div class="columns is-mobile">
              <!-- AIRLINE LOGO -->

              <div class="column is-narrow has-text-centered wrap">
                <div class="mt-1 airlineLogo">
                  <img
                    width="20"
                    :src="$helpers.airlineLogo(journey.airlineCode, 20, 20)"
                    :title="$helpers.airlineName(journey.airlineCode)"
                  />
                </div>
              </div>
              <!-- FROM-TO -->
              <div class="column is-narrow">
                <div class="columns is-mobile is-gapless mb-2">
                  <div class="column is-narrow mr-2">
                    <div
                      data-test="result-mobile-journey-from"
                      class="has-text-weight-bold"
                    >
                      {{ journey.from }}
                    </div>
                  </div>
                  <div class="column is-narrow mr-2">
                    <span class="is-size-7 mt-1 is-block">
                      <b-icon
                        icon="arrow-right"
                        size="is-small"
                        class="has-text-grey-light"
                      ></b-icon>
                    </span>
                  </div>
                  <div class="column is-narrow mr-2">
                    <div
                      class="has-text-weight-bold"
                      data-test="result-mobile-journey-to"
                    >
                      {{ journey.to }}
                    </div>
                  </div>
                </div>
                <div class="columns mb-1">
                  <div
                    data-test="result-mobile-airline-name"
                    class="is-size-7 has-text-grey-light ml-3"
                  >
                    {{ $helpers.airlineName(journey.airlineCode) }}
                  </div>
                  <div v-if="roundTripDifferentAirports && journeyIndex == 1">
                    <span class="has-text-danger is-size-7"
                      >multiple airports</span
                    >
                  </div>
                </div>

                <div class="mt-3">
                  <!-- DEPARTURE-ARRIVAl -->
                  <p>
                    <span
                      class="is-size-7"
                      data-test="result-mobile-flight-mobile-time"
                    >
                      {{ journey.legs[0].departingAt.time | formatTime }} -
                      {{
                        journey.legs.slice(-1).pop().arrivingAt.time
                          | formatTime
                      }}
                    </span>
                    <span class="is-inline is-size-7 has-text-grey-light">
                      <span
                        class="is-size-7 has-text-danger"
                        v-if="journey.dateDifference > 0"
                      >
                        +{{ journey.dateDifference }}
                        <span v-if="journey.dateDifference == 1">day</span>
                        <span v-if="journey.dateDifference > 1">days</span>
                      </span>
                    </span>
                  </p>
                  <!-- DURATION -->
                  <p>
                    <span
                      data-test="result-mobile-total-duration"
                      class="has-text-grey-dark is-size-7 mr-2"
                      >{{ journey.travelDuration | formatDuration }}</span
                    >
                    <span
                      data-test="result-mobile-total-stop"
                      class="has-text-grey is-size-7"
                      >{{ (journey.legs.length - 1) | formatLayovers }}</span
                    >

                    <span
                        v-for="(layover, index) in journey.layovers"
                        :key="`layover-${index}`"
                        class="is-size-7 has-text-grey"
                      >

                      <span class="mx-1 has-text-grey-light">
                        &bull;
                      </span>

                      <span class="has-text-weight-bold mr-1">
                        {{ layover.airport }} 
                      </span>
                    
                      
                      <span v-bind:class="getLayoverClass(layover.durationInMinutes)">
                        {{ layover.durationInMinutes | formatDuration }}
                      </span>

                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- PRICE RANGE -->
            <div class="has-text-right mr-2">
              <span class="has-text-grey-dark is-size-7 has-text-weight-bold">
                <span data-test="result-mobile-price-range-display">{{
                  priceRangeDisplay
                }}</span>
              </span>
            </div>

            <!-- UNUSED TICKET -->
            <div
              class="has-text-right mr-2"
              v-if="unusedTickets.includes(journey.airlineCode)"
            >
              <b-icon
                icon="currency-usd"
                size="is-small"
                type="is-info"
              ></b-icon>
            </div>

            <!-- FARE RULES (One-Way Only) -->
            <div class="has-text-right mr-2" v-if="isOneWay">
              <div class="is-clickable" @click="fareRulesModal(journey)">
                <b-icon
                  icon="alpha-f-circle"
                  size="is-default"
                  class="has-text-grey-lighter"
                >
                </b-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="is-flex is-justify-content-center mt-3">
          <!-- FLIGHT INFO -->
      
            <div class="is-flex">
              <div
                class="is-inline-block mr-1 is-clickable"
                data-test="result-mobile-view-details"
                @click="toggleDetails"
              >
                <!--              <b-icon-->
                <!--                  icon="information"-->
                <!--                  size="is-default"-->
                <!--                  class="has-text-grey-lighter"-->
                <!--              />-->
                <b-button type="is-outlined" size="is-small"
                  >View Details</b-button
                >
              </div>
            </div>
 
      
            <div class="is-flex">
              <div v-if="!isOneWay">
                <div
                  class="is-inline-block is-clickable"
                  data-test="result-mobile-select"
                  @click="selectOption(journey)"
                  v-if="!isSelected"
                  style="width: 70px;"
                >
                  <b-button type="is-outlined" size="is-small">Select</b-button>
                </div>
                <div
                  class="is-inline-block is-clickable"
                  data-test="result-mobile-unselect"
                  @click="unselectOption(journey)"
                  v-if="isSelected"
                  style="width: 70px;"
                >
                  <b-button type="is-outlined" size="is-small"
                    >Unselect</b-button
                  >
                </div>
              </div>
              <div v-if="isOneWay">
                <div
                  class="is-inline-block is-clickable"
                  @click="checkSubmission(findOneWayItem(journey))"
                  data-test="result-mobile-button-book"
                  style="width: 70px;"
                >
                  <b-button type="is-primary" size="is-small">Book</b-button>
                </div>
              </div>
           
          </div>
        </div>
      </div>
      <!-- end of Mobile View  -->
    </div>
    <!-- end of .journey-container -->

    <!-- SHOW DETAILS OF THE FLIGHT -->

<!--
    <b-sidebar
      type="is-light"
      :fullheight="true"
      :fullwidth="false"
      :overlay="false"
      :right="true"
      v-model="showDetails"
      scroll="keep"
      mobile="fullwidth"
    >
      <b-button
        label="Close"
        @click="showDetails = false"
        type="is-info"
        expanded
        style="border-radius:0px"
      />

      <div class="card">
        <FlightDetails v-if="showDetails" :journeys="[journey]" />
      </div>
    </b-sidebar>
  -->

  </div>
</template>

<script>
import bookingMixin from "../../../mixins/bookingMixin";
import { eventBus } from "../../../main";
import NDCTag from "../../Tags/NDCTag.vue";
import FlightDetails from "./FlightDetails.vue";
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag";
import SeatMapMenu from "../../SeatMap/SeatMapMenu";
import FareRules from "./FareRules";
import PreferredVendorTag from "../../Tags/PreferredVendorTag.vue";
import AddMeetingGuest from "@/components/Meetings/AddMeetingGuest";
import meetingsMixin from "@/mixins/meetingsMixin";

export default {
  name: "JourneyGroupItem",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    //FlightDetails,
    // OutOfPolicyTag,
    PreferredVendorTag,
    NDCTag
  },
  props: {
    journey: Object,
    itineraryPrices: [],
    travelPolicy: {},
    rawItems: {},
    segmentIndex: {},
    preferredVendors: Array,
  },
  data: function() {
    return {
      roundTripDifferentAirports: false,
      showDetails: false,
    };
  },
  computed: {
    ndcFare(){
      return this.firstPossibleSolution?.offer != null;
    },
    //determine whether the flight details display is set to the current row
    activeRow(){
      return this.$store.state.bookTravel.flightDetails.show && (JSON.stringify(this.$store.state.bookTravel.flightDetails.journeys) === JSON.stringify([this.journey]));
    },
    styleObject() {
      let obj = {};
      if (this.activeRow) {
        obj = {
          background: "rgba(248, 234, 207, 0.6)",
        };
      }
      return obj;
    },
    firstPossibleSolution(){
      return this.possibleItems[0];
    },
    upsellsCount() {
      return this.firstPossibleSolution?.upsellsCount;
    },
    fareDescription() {
      /* MT - We are grabbing the fare description from the first "possible" matching item; there is a chance this fareDescription 
      may differ from the one chosen on the second step or the summary page */
      return this.firstPossibleSolution?.fareFamily?.familyDescription || '';
    },
    moreResults() {
      return this.$store.state.bookTravel.flightSearchMoreResults;
    },

    currentSelectedJourney() {
      return this.selectedUnbundledJourneys[this.segmentIndex];
    },
    currentSelectedClass() {
      return this.currentSelectedJourney == this.journey.uniqueKey
        ? "is-selected"
        : "";
    },
    isSelected() {
      return this.currentSelectedJourney == this.journey.uniqueKey;
    },

    /* MT NOTE - If there are selected segments left over from previous searches, 
      all of our items/pricing calculations below will break. Its important to clear the 
      selectedUnbundledJourneys Vuex state prior to each new search. Alternatively, we may 
      want to consider adding a key   
      */

    //Object containing ids of all user selected segments
    selectedUnbundledJourneys() {
      return this.$store.getters["bookTravel/getSelectedUnbundledJourneys"];
    },

    //Returns array containing ids of selected segments PRIOR to the current segment
    priorSelectedJourneyIds() {
      //convert to an array
      let journeys = Object.values(this.selectedUnbundledJourneys);

      //If the user has already selected an option for the current segement, ignore it here
      let currentIndex = this.segmentIndex - 1;
      journeys.splice(currentIndex, 1);

      return journeys;
    },

    //Find flight items that contain all of the proposed journeys
    possibleItems() {
      let journeys = [];

      //get previously selected journeys, if any
      journeys = journeys.concat(this.priorSelectedJourneyIds);

      //include proposed journey item for the current option
      journeys.push(this.journey.uniqueKey);

      //look for flight item(s) that contains all (every) of the current journey items
      let items = this.rawItems.filter((item) => {
        return journeys.every((journey) => {
          let itemJourneys = item.journeys.map((journey) => journey.uniqueKey);

          return itemJourneys.includes(journey);
        });
      });

      return items;
    },

    //return pricing for all of the the possible items
    possiblePrices() {
      let prices = this.possibleItems.map((item) => {
        return item.pricing.total;
      });
      prices.sort((a, b) => a - b);
      return prices;
    },

    minPrice() {
      let prices = this.possiblePrices;
      return prices[0];
    },
    maxPrice() {
      let prices = this.possiblePrices;
      return prices[prices.length - 1];
    },
    priceRangeDisplay() {
      let display = "$" + this.minPrice;

      if (this.minPrice != this.maxPrice) {
        display = display + " - " + this.maxPrice;
        // display = display + '+'
      }

      return display;
    },

    solutionAirlineCodes() {
      var airlines = [];

      for (let journey of this.journey) {
        airlines.push(journey.airlineCode);
      }

      return airlines;
    },
    solutionAirlineNames() {
      var airlineNames = [];

      for (let airlineCode of this.solutionAirlineCodes) {
        airlineNames.push(this.airlineNames[airlineCode]);
      }

      return airlineNames;
    },
    airlineNames() {
      return this.$store.state.vendors.airlines;
    },
    unusedTickets() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].unusedTicketAirlines;
    },
    isPreferredVendor() {
      return this.preferredVendors.includes(this.journey.airlineCode);
    },
    /*
      prices() {
        let prices = this.itineraryPrices

        // Filter
        let filteredPrices = prices.filter((item) => {
          return item.journeys.includes(this.journey.uniqueKey)
        })

        // console.log(this.selectedUnbundledJourneys)

        // Filter again if other journeys are already selected (uncommented, because this breaks pricing map for anchored flights)
        // if (this.otherSelectedJourneysCount > 0) {
        //   //console.log(this.otherSelectedJourneysCount)
        //   //console.log(this.otherSelectedJourneys)
        //   filteredPrices = filteredPrices.filter((item) => {
        //
        //     let matches = 0
        //     let journeysCount = 0
        //
        //     for (let journeyIndex of Object.keys(this.otherSelectedJourneys)) {
        //       journeysCount++
        //
        //       if (item.journeys.includes(this.otherSelectedJourneys[journeyIndex])) {
        //         matches++
        //       }
        //     }
        //     // console.log(matches + ' : ' + journeysCount)
        //     return matches == journeysCount
        //
        //   })
        // }

        // console.log(filteredPrices)
        // Get total prices for each
        let totalPrices = []
        for (let priceItem of filteredPrices) {
          totalPrices.push(priceItem.pricing.total)
        }
        // Sort low to high
        totalPrices.sort(function(a,b) {
          return a-b
        })
        return totalPrices;
      },
      */

    /*
      otherSelectedJourneys() {

        // Remove the current index
        let otherSelectedJourneys = Object.assign({}, this.selectedUnbundledJourneys)

        //console.log(otherSelectedJourneys)

        delete otherSelectedJourneys[this.journey.segmentIndex]

        //console.log(otherSelectedJourneys)

      return otherSelectedJourneys;
      },
      otherSelectedJourneysCount() {
        return Object.keys(this.otherSelectedJourneys).length
      },
      */
  },
  methods: {
    toggleDetails() {
      if (this.$store.state.bookTravel.flightDetails.show) {
        this.$store.commit("bookTravel/HIDE_FLIGHT_DETAILS");
      } else {
        let details = {
          show: true,
          journeys: [this.journey]
        }
        this.$store.commit("bookTravel/SET_FLIGHT_DETAILS", details);
      }
    },
    getLayoverClass(durationInMinutes) {
      if (durationInMinutes > 180 || durationInMinutes < 45) {
        return 'has-text-danger'
      }

      return ''
    },
    selectOption(journey) {
      // console.log('selected from the segment: ', this.segmentIndex);

      //this.showDetails = false;
      this.$store.commit("bookTravel/HIDE_FLIGHT_DETAILS");
      let payload = {
        segmentIndex: journey.segmentIndex,
        uniqueKey: journey.uniqueKey,
        journey: journey,
      };
      // console.log('option selected: ' + JSON.stringify(payload))
      // console.log('unbundledJourneySelected > JourneySummaryUnbundled: ' + segmentIndex)
      this.$emit("unbundledJourneySelected", payload);
      this.$store.commit("bookTravel/SELECT_UNBUNDLED_JOURNEY", payload);
    },
    unselectOption(journey) {
      // console.log('UN-selectOption FROM segment ', this.segmentIndex);
      //let parts = journey.uniqueIndex.split('.');
      let segmentIndex = journey.segmentIndex;

      //MT - this code is using both this.segmentIndex and journey.segmentIndex - are these ever not the same?
      eventBus.$emit("unselect-journey", this.segmentIndex);
      this.$store.commit("bookTravel/UNSELECT_UNBUNDLED_JOURNEY", segmentIndex);
    },
    goToSeatMaps() {
      var details;
      details = {
        parent: this,
        component: SeatMapMenu,
        props: {
          activeTab: 0,
          flightProp: [this.journey],
          preview: true,
        },
        hasModalCard: true,
        trapFocus: true,
      };
      this.$buefy.modal.open(details);
    },
    fareRulesModal() {
      let details = {
        parent: this,
        component: FareRules,
        props: {
          journeys: [this.journey],
        },
        trapFocus: false,
        width: 700,
      };
      this.$buefy.modal.open(details);
    },
    findOneWayItem(journey) {
      let items = this.rawItems;

      let match = items.filter((item) => {
        return item.journeys[0].uniqueKey === journey.uniqueKey;
      });

      if (match.length > 0) {
        // console.log('match found:', match);
        this.journey.isSelectable = match[0].isSelectable;
        this.journey.immediateTravelBookingAdvice =
          match[0].immediateTravelBookingAdvice;
        // this.journey.pricing =  match[0].pricing;
        return match[0];
      } else {
        return [];
      }
    },
    checkSubmission(sol) {
      // console.log('checkSubmission', sol);

      if (sol.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a flight with a departure time in the next few hours. Please watch your email for your Final Ticketed Itinerary.  If you do not receive your Final Ticketed Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.   ",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.submitted(sol),
        });
      } else {
        this.submitted(sol);
      }
    },
    submitted(value) {
      // console.log('submitted', value);
      this.$store.dispatch("bookTravel/alterResult", value);

      if (this.pathMixin_isMeeting) {
        this.meetingRouter();

        if (this.meetingInfo.allowedToBringGuest) {
          this.$buefy.modal.open({
            parent: this,
            component: AddMeetingGuest,
            props: {},
            hasModalCard: true,
            trapFocus: true,
            width: 650,
          });
        }
      } else {
        this.$nav.pushRouteTo({ name: "BookingItinerary" });
      }
    },
  },
  mounted() {
    // console.log('itienrary prices', this.itineraryPrices);
    // console.log('journey', this.journey);
  },
};
</script>

<style scoped lang="scss">

</style>
